<template>
  <div class="container-fluid">
    <div
      class="row"
      v-loading="paymentStatusLoading"
      element-loading-text="Please wait while we confirm your payment ..."
    >
      <div class="col-md-6">
        <!-- top Address -->
        <div
          class="row vh-100 justify-content-center align-items-md-center align-items-start"
        >
          <div class="col-md-12">
            <div
              class="row eventpictbg justify-content-center d-block d-md-none"
            >
              <div class="col-md-12 d-flex justify-content-center mb-4">
                <img :src="bannerUrl" class="col-10 col-md-12" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 mb-3 text-center">
                <span class="font-weight-bold h4 primary--text">
                  {{ eventData.name }}
                </span>
                <!-- will be use later -->
                <!-- <span v-if="fullEventData.registrationAmount">
                  - {{ tenantCurrency }}
                  {{ fullEventData.registrationAmount }}</span
                > -->
                <div class="font-weight-bold">Event Registration</div>
                <div class="italicize">{{ eventData.date }}</div>
              </div>
            </div>

            <div
              class="row d-flex justify-content-center"
              v-if="
                fullEventData.registrationCutOffTime &&
                new Date().toISOString() >=
                  new Date(fullEventData.registrationCutOffTime).toISOString()
              "
            >
              <img
                src="../../assets/registration_closed.jpeg"
                class="event-closed"
              />
            </div>

            <!--end top Address -->

            <!-- top area -->
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-7">
                <p
                  class="font-weight-600 text-center primary-text"
                  v-if="person.personId && loaded && !showLoading"
                >
                  {{
                    navigatorLang === "en-US"
                      ? "Your details were found, please confirm to register."
                      : $t("event.detailsWereFound")
                  }}
                </p>
                <p
                  class="font-weight-600 text-center primary-text"
                  v-if="
                    !person.personId &&
                    !showLoading &&
                    loaded &&
                    !fetchingFailed
                  "
                >
                  {{
                    navigatorLang === "en-US"
                      ? " Please fill the form and confirm the registration"
                      : $t("event.formAndConfirm")
                  }}
                </p>
              </div>
            </div>

            <div
              class="row"
              v-if="
                !fullEventData.registrationCutOffTime ||
                new Date().toISOString() <=
                  new Date(fullEventData.registrationCutOffTime).toISOString()
              "
            >
              <div
                class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-1 font-weight-700"
              >
                <label for="">{{
                  navigatorLang === "en-US"
                    ? "Phone Number"
                    : $t("event.phoneNumber")
                }}</label>
              </div>
              <div class="col-md-7">
                <span class="p-input-icon-left w-100">
                  <!-- <i class="pi pi-phone icon" /> -->
                  <!-- <input @blur="checkCharacter" @input="CheckXterAfterEleven" class="form-control w-100" type="text"
                  v-model="enteredValue" aria-required="" placeholder="Enter your phone number" /> -->
                  <el-input
                    @blur="checkCharacter"
                    class="w-100"
                    type="number"
                    v-model="enteredValue"
                    aria-required=""
                    placeholder="Enter your phone number"
                  >
                    <template #prefix>
                      <el-icon class="el-input__icon">
                        <PhoneFilled />
                      </el-icon>
                    </template>
                  </el-input>
                </span>
                <!-- v-if="autosearch && !person.name" -->
              </div>
              <div
                class="col-12 col-md-4 offset-0 offset-md-4 mt-4"
                v-if="!names"
              >
                <el-button
                  size="large"
                  round
                  :color="primarycolor"
                  class="w-100 text-white border-0 text-center c-pointer"
                  >{{
                    navigatorLang === "en-US"
                      ? "Register"
                      : $t("event.register")
                  }}</el-button
                >
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-3"></div>
              <div class="col-md-5 offset-1">
                <div class="loading-div my-5" v-if="showLoading">
                  <div style="width: 3rem; height: 3rem" role="status">
                    <el-icon class="is-loading">
                      <Loading />
                    </el-icon>
                  </div>
                  <p>
                    {{
                      navigatorLang === "en-US"
                        ? "Fetching your details"
                        : $t("event.fetchingDetails")
                    }}...
                  </p>
                </div>
                <!-- v-if="autosearch && !person.name" -->
              </div>
            </div>
            <!-- end of top area -->

            <!--start of top area button -->
            <div class="row" :class="{ 'mb-4': showLoading }" v-if="false">
              <div class="col-md-3 text-md-right"></div>
              <div
                class="col-md-5 text-center col-sm-2"
                :class="{ 'mt-4': showLoading }"
              >
                <p
                  class="text-danger"
                  v-if="showNoPhoneError"
                  :class="{ 'my-1': showLoading }"
                >
                  {{
                    navigatorLang === "en-US"
                      ? "Please enter your phone number"
                      : $t("event.pleaseEnterNumber")
                  }}
                </p>
                <el-button
                  class="default-btn add-btn"
                  @click="checkCharacter"
                  ref="submitBtn"
                  v-if="!appltoggle && !showLoading"
                  round
                >
                  <!-- <i class="fas fa-circle-notch fa-spin" v-if="loading"></i> -->

                  {{
                    navigatorLang === "en-US" ? "Submit" : $t("event.submit")
                  }}
                </el-button>
              </div>
            </div>
            <!--end of top area button -->

            <!-- start of bottom area -->
            <div class="row" v-if="appltoggle && !showLoading">
              <div class="col-md-12">
                <div
                  class="row"
                  v-if="
                    selectedCustomField.find(
                      (i) => i.toLowerCase() == 'card/checkin number'
                    )
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">
                      {{
                        navigatorLang === "en-US"
                          ? "Card number"
                          : $t("event.cardNumber")
                      }}
                    </label>
                  </div>
                  <div class="col-md-7">
                    <el-input
                      class="w-100 border"
                      placeholder="Card Number"
                      type="text"
                      aria-required=""
                      v-model="checkinCode"
                    />
                  </div>
                </div>

                <div class="row mt-2 my-2">
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US" ? "Name" : $t("event.name")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <span class="p-input-icon-left w-100">
                      <el-input
                        class="w-100"
                        type="text"
                        v-model="person.name"
                        aria-required=""
                        :disabled="disabled"
                        placeholder="Name"
                      >
                        <template #prefix>
                          <el-icon class="el-input__icon">
                            <User />
                          </el-icon>
                        </template>
                      </el-input>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US" ? "Email" : $t("event.email")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <span class="p-input-icon-left w-100 my-md-3">
                      <el-input
                        class="w-100"
                        :class="{ 'border border-warning': emailNotification }"
                        type="text"
                        v-model="person.email"
                        aria-required=""
                        :disabled="
                          (person.personId && personData.email) ||
                          (personData.email !== '' && personData.email !== null)
                        "
                        placeholder="Email"
                      >
                        <template #prefix>
                          <el-icon class="el-input__icon">
                            <Message />
                          </el-icon>
                        </template>
                      </el-input>
                      <div
                        class="small-text notify-text"
                        v-if="emailNotification"
                      >
                        {{ emailNotification }}
                      </div>
                    </span>
                  </div>
                </div>

                <div
                  class="row my-2"
                  v-if="
                    selectedCustomField.find(
                      (i) => i.toLowerCase() == 'address'
                    )
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US"
                        ? "Address"
                        : $t("event.address")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <span class="p-input-icon-left w-100">
                      <el-input
                        class="w-100 border"
                        type="text"
                        v-model="person.address"
                        aria-required=""
                        :disabled="personHasAddress"
                        placeholder="Address"
                      >
                        <template #prefix>
                          <el-icon class="el-input__icon">
                            <Location />
                          </el-icon>
                        </template>
                      </el-input>
                    </span>
                  </div>
                </div>

                <div
                  class="row my-3"
                  v-if="
                    selectedCustomField.find(
                      (i) => i.toLowerCase() == 'birthday'
                    )
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US"
                        ? "Birthday"
                        : $t("event.birthday")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-6">
                        <el-select-v2
                          v-model="birthDay"
                          class="w-100"
                          placeholder="Day"
                          :options="[
                            { label: 'Day', value: 0 },
                            ...days.map((i) => ({ label: i, value: i })),
                          ]"
                          size="large"
                        />
                      </div>
                      <div class="col-6">
                        <el-select-v2
                          v-model="birthMonth"
                          class="w-100"
                          placeholder="Month"
                          :options="[
                            { label: 'Month', value: 0 },
                            ...months.map((i) => ({ label: i, value: i })),
                          ]"
                          size="large"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row my-3"
                  v-if="
                    selectedCustomField.find(
                      (i) => i.toLowerCase() == 'wedding'
                    )
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US"
                        ? "Wedding"
                        : $t("event.wedding")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-4">
                        <el-select-v2
                          v-model="dayOfWedding"
                          class="w-100"
                          placeholder="Day"
                          :options="[
                            { label: 'Day', value: 0 },
                            ...days.map((i) => ({ label: i, value: i })),
                          ]"
                          size="large"
                        />
                      </div>
                      <div class="col-4">
                        <el-select-v2
                          v-model="monthOfWedding"
                          class="w-100"
                          placeholder="Month"
                          :options="[
                            { label: 'Month', value: 0 },
                            ...months.map((i) => ({ label: i, value: i })),
                          ]"
                          size="large"
                        />
                      </div>
                      <div class="col-4">
                        <el-select-v2
                          v-model="yearOfWedding"
                          class="w-100"
                          placeholder="Year"
                          :options="[
                            { label: 'Year', value: 0 },
                            ...weddingYearsArr.map((i) => ({
                              label: i,
                              value: i,
                            })),
                          ]"
                          size="large"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row my-3"
                  v-if="
                    selectedCustomField.find(
                      (i) => i.toLowerCase() == 'marital status'
                    )
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US"
                        ? "Marital Status"
                        : $t("event.maritalStatus")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <el-select-v2
                      v-model="maritalStatusId"
                      @change="setSelectedMaritalStatus"
                      :options="
                        maritalStatus.map((i) => ({
                          label: i.value,
                          value: i.id,
                        }))
                      "
                      placeholder="Marital status"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>
                <div
                  class="row my-3"
                  v-if="
                    selectedCustomField.find((i) => i.toLowerCase() == 'gender')
                  "
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{
                      navigatorLang === "en-US" ? "Gender" : $t("event.gender")
                    }}</label>
                  </div>
                  <div class="col-md-7">
                    <el-select-v2
                      v-model="genderId"
                      @change="setSelectedGender"
                      :options="
                        gender && gender.length > 0
                          ? gender.map((i) => ({ label: i.value, value: i.id }))
                          : []
                      "
                      placeholder="Gender"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>
                <div
                  class="row my-3"
                  v-for="item in dynamicCustomFields"
                  :key="item.id"
                >
                  <div
                    class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-2 font-weight-700"
                  >
                    <label for="">{{ item.label }}</label>
                  </div>
                  <div class="col-md-7">
                    <el-input
                      v-if="item.controlType == 0"
                      class="w-100"
                      type="text"
                      aria-required=""
                      v-model="item.data"
                    />
                    <el-input
                      v-if="item.controlType == 8"
                      class="w-100"
                      type="text"
                      aria-required=""
                      v-model="item.data"
                    />
                    <el-select-v2
                      v-else-if="item.controlType == 1"
                      v-model="item.data"
                      :options="
                        item.parameterValues
                          .split(',')
                          .map((i) => ({ label: i, value: i }))
                      "
                      placeholder="Select option"
                      size="large"
                      class="w-100"
                    />
                    <el-checkbox
                      v-else-if="item.controlType == 2"
                      v-model="item.data"
                    />
                    <el-date-picker
                      v-if="item.controlType == 3"
                      v-model="item.data"
                      type="datetime"
                      format="DD/MM/YYYY hh:mm:ss"
                      size="large"
                      class="w-100"
                    />
                    <el-input
                      v-if="item.controlType == 4"
                      class="w-100 border"
                      type="email"
                      aria-required=""
                      v-model="item.data"
                    />
                    <input
                      v-if="item.controlType == 7"
                      class="w-100 border"
                      type="file"
                      aria-required=""
                    />
                    <el-input
                      v-if="item.controlType == 5"
                      class="w-100 border"
                      type="number"
                      aria-required=""
                      v-model="item.data"
                    />
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-8 offset-md-3 mt-3 align-self-center">
                    <el-checkbox v-model="displayFamily" />
                    <span class="ml-3">Do you want to register your family for this event?</span>
                  </div>
                </div> -->

                <div class="row mt-4" v-if="displayFamily">
                  <FamilyWards
                    :family="familyWards"
                    :memberRoles="memberRoles"
                    :fullEventData="fullEventData"
                    @newmember="setNewMember"
                    @nofamilynewmember="setMemberDetails"
                  />
                </div>

                <div class="row my-2">
                  <div class="col-md-12">
                    <div class="row justify-content-center">
                      <div
                        class="col-md-5 d-flex justify-content-center cursor-pointer"
                      >
                        <div class="font-weight-bold" round @click="notme">
                          <u>{{
                            navigatorLang === "en-US"
                              ? "Not Me"
                              : $t("event.notMe")
                          }}</u>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 py-3 text-center">
                    <div class="row justify-content-center">
                      <div class="col-md-6">
                        <!-- <el-button
                          data-toggle="modal"
                          class="w-100"
                          data-target="#PaymentOptionModal" -->
                        <el-button
                          size="large"
                          :color="primarycolor"
                          @click="confirmCheck()"
                          v-if="
                            fullEventData.paymentFormId ||
                            fullEventData?.paymentGateWayOptions?.length > 0
                          "
                          :disabled="
                            !person.name ||
                            person.name.length < 1 ||
                            !person.email ||
                            disableClick
                          "
                          round
                        >
                          {{
                            navigatorLang === "en-US"
                              ? "Make payment to register"
                              : $t("event.paymentToRegister")
                          }}
                        </el-button>
                        <el-button
                          size="large"
                          class="mt-3 w-100 mt-sm-0 text-white"
                          :color="primarycolor"
                          @click="confirmToRegister"
                          :disabled="
                            !person.name ||
                            person.name.length < 1 ||
                            disableClick
                          "
                          round
                          v-else
                        >
                          {{
                            navigatorLang === "en-US"
                              ? "Confirm to register"
                              : $t("event.confirmRegister")
                          }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row justify-content-center"
              v-if="
                fullEventData.registrationCutOffTime &&
                new Date().toISOString() <=
                  new Date(fullEventData.registrationCutOffTime).toISOString()
              "
            >
              <div class="col-10 col-md-5 text-center">
                <!-- Button code -->
                <div title="Add to Calendar" class="addeventatc w-100">
                  {{
                    navigatorLang === "en-US"
                      ? "Add to Calendar"
                      : $t("event.addCalendar")
                  }}
                  <span class="start">{{ fullEventData.eventDate }}</span>
                  <span class="timezone">{{
                    Intl.DateTimeFormat().resolvedOptions().timeZone
                  }}</span>
                  <span class="title">{{ eventData.name }}</span>
                  <span class="description">{{
                    fullEventData.eventDetails
                  }}</span>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div
                class="col-md-3 d-md-flex align-items-center justify-content-end text-md-right mt-3 font-weight-700"
              ></div>
              <div class="col-md-7 mt-2">
                <p class="text-center fw-normal" style="color: #136acd">
                  <a
                    href="https://churchplus.co"
                    class="text-decoration-none primary--text"
                    target="_blank"
                    >Powered by CHURCHPLUS</a
                  >
                </p>
              </div>
              <!-- Modal -->
              <div
                class="modal fade"
                id="PaymentOptionModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header bg-modal">
                      <h5 class="modal-title" id="exampleModalLongTitle">
                        {{
                          navigatorLang === "en-US"
                            ? "Payment methods"
                            : $t("event.paymentMethods")
                        }}
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true" ref="close">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body p-0 bg-modal pb-5">
                      <!-- <PaymentOptionModal
                        :formData="eventPaymentForm"
                        :close="close"
                        :donation="donationObj"
                        @selectedgateway="setGateway"
                        :currency="paymentFormCurrency"
                        @donationconfirmed="setConfirmDonation"
                        :initializePaymentResponse="initializePaymentResponse"
                        :callPayment="callPayment"
                        @resetcallpaymentprops="resetCallPayment"
                        :isPaymentConnected="isPaymentConnected"
                      /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 eventpictbg d-none d-md-block">
        <div class="row vh-100 justify-content-center align-items-center">
          <div class="col-md-11">
            <img :src="bannerUrl" class="w-100" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-drawer v-model="checkoutDrawer" :show-close="false" size="100%">
    <div>
      <div class="d-flex justify-content-end">
        <el-icon
          :size="30"
          class="c-pointer"
          color="red"
          @click="checkoutDrawer = false"
        >
          <CircleClose />
        </el-icon>
      </div>
      <iframe
        sandbox="allow-downloads allow-scripts allow-same-origin"
        :src="checkoutURL"
        width="100%"
        height="800"
        frameborder="0"
      ></iframe>
    </div>
  </el-drawer>
  <el-dialog
    v-model="paymentResponseDialog"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : xsOnly ? `90%` : `70%`"
    align-center
    class="QRCodeDialog p-4"
  >
    <PaymentStatusDialog
      :paymentStatusMessage="paymentStatusMessage"
      @closestatusdialog="paymentResponseDialog = false"
    />
  </el-dialog>
  <el-dialog
    style="border-radius: 25px"
    v-model="showPaymentGatewayOptions"
    title=""
    :show-close="false"
    :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
  >
    <div class="row justify-content-center">
      <div class="col-md-12 d-flex justify-content-end">
        <el-button link @click="closePaymentModal">
          <span aria-hidden="true" ref="close">&times;</span>
        </el-button>
      </div>
      <div
        class="col-md-10 mt-4 h-100 bg-white mb-5"
        v-if="showPaymentGatewayOptions"
      >
        <div class="row justify-content-center align-items-center">
          <div class="col-md-12 d-flex justify-content-center">
            <div class="col-md-12">
              <PaymentGatewayDialog
                :formData="fullEventData"
                :donation="donationObj"
                :close="close"
                :entityType="3"
                :email="person.email"
                :amount="fullEventData.registrationAmount || 0"
                :converted="computeAmount"
                @selected-gateway="setGateway"
                :currency="paymentFormCurrency.shortCode"
                @payment-successful="successfulPayment"
                @transaction-reference="setTransactionReference"
                @paystack-amount="setPaystackAmount"
                :initializePaymentResponse="initializePaymentResponse"
                :callPayment="callPayment"
                @resetcallpaymentprops="resetCallPayment"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    class="border-radius-20"
    v-model="paymentFailed"
    align-center
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
  >
    <div class="row justify-content-center">
      <div class="col-md-10 mt-4 bg-white mb-5">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-8 d-flex justify-content-center">
            <div class="col-4">
              <img
                class="w-100"
                src="../../assets/mobileonboarding/sub-failed.png"
                alt=""
              />
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-center">
            <div class="col-md-10 col-12 px-0">
              <div
                class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                style="color: #d21615"
              >
                Payment failed!
              </div>
            </div>
          </div>
          <div class="col-md-10 d-flex my-5 justify-content-center">
            <div class="col-md-8">
              <el-button
                @click="tryAgain"
                :color="primarycolor"
                size="large"
                class="w-100"
                round
                >Try again</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    class="border-radius-20"
    v-model="paymentDone"
    align-center
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
  >
    <div class="row justify-content-center">
      <div class="col-md-10 mt-3 bg-white mb-3" v-if="paymentSuccessful">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-10 col-12 d-flex justify-content-center">
            <div class="col-6">
              <img
                class="w-100"
                src="../../assets/mobileonboarding/sub-successful.gif"
                alt=""
              />
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-center">
            <div class="col-md-10 col-12 px-0">
              <div
                class="text-head font-weight-bold col-md-12 px-0 h2 text-center"
                style="color: #78b348"
              >
                Your Payment is Successful!
              </div>
            </div>
          </div>
          <div class="col-md-10 d-flex my-5 justify-content-center">
            <div class="col-md-8">
              <el-button
                @click="resetForm"
                :color="primarycolor"
                size="large"
                class="w-100"
                round
                >Done
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, ref, inject } from "vue";
import axios from "@/gateway/backendapi";
// import router from "../../router/index";
import { useRoute } from "vue-router";
import dateFormatter from "@/services/dates/dateformatter";
import stopProgressBar from "../../services/progressbar/progress";
import swal from "sweetalert";
import PaymentOptionModal from "../../components/paymentoption/EventRegPayment.vue";
import PaymentGatewayDialog from "../../components/paymentoption/PaymentGatewayDialog.vue";
import finish from "../../services/progressbar/progress";
import store from "../../store/store";
import FamilyWards from "./component/EventRegFamilyWards.vue";
import { ElMessage } from "element-plus";
import { ElLoading } from "element-plus";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import PaymentStatusDialog from "../../components/payment/PaymentStatusDialog.vue";
import { ConfirmPaystackTransaction } from "../../services/settings/integrations";
import { paystackTransactionStatusEnum } from "../../services/constant";

const primarycolor = inject("primarycolor");
const connectName = ref("");
const yearOfWedding = ref(null);
const monthOfWedding = ref(null);
const navigatorLang = ref(navigator.language);
const dayOfWedding = ref(null);
const selectedMaritalStatus = ref("");
const showPaymentGatewayOptions = ref(false);
const selectedGender = ref("");
const appltoggle = ref(false);
const paymentFailed = ref(false);
const paymentDone = ref(false);
const names = ref("");
const address = ref("");
const enteredValue = ref("");
const emailNotification = ref("");
const loading = ref(false);
const autosearch = ref(false);
const noError = ref(true);
const person = ref({});
const maritalStatus = ref({});
const route = useRoute();
const submitBtn = ref(null);
const loaded = ref(false);
const close = ref("");
const donationObj = ref({});
const fullEventData = ref({});
const currentUser = ref(store.getters.currentUser);
const displayFamily = ref(false);
const memberRoles = ref([]);
const familyWards = ref({ familyMembers: [] });
const familyMembers = ref([]);
const authorizebutton = ref();
const paymentSuccessful = ref(false);
const signout = ref();
const disableClick = ref(false);
const selectedGateway = ref("");
const donationNewProps = ref({});
const maritalStatusId = ref(null);
const birthMonth = ref("");
const gender = ref({});
const genderId = ref(null);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const birthDay = ref("");
const days = ref([
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23,
  24, 25, 26, 27, 28, 29, 30, 31,
]);
const eventPaymentForm = ref({});
const callPayment = ref(false);
const initializePaymentResponse = ref({});
const paymentFormCurrency = ref({});
const isPaymentConnected = ref(false);
const checkoutURL = ref("");
const checkoutDrawer = ref(false);
const paymentStatusLoading = ref(false);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const paymentResponseDialog = ref(false);
const paymentStatusMessage = ref("");

const setSelectedMaritalStatus = () => {
  selectedMaritalStatus.value = maritalStatus.value.find((i) => {
    return i.id == maritalStatusId.value;
  });
};

const setPaystackAmount = () => {
  delete donationObj.value[amount];
  donationObj.value.amount = computeAmount.value * 100;
};

const setSelectedGender = () => {
  selectedGender.value = gender.value.find((i) => {
    return i.id == genderId.value;
  });
};
const closePaymentModal = () => {
  showPaymentGatewayOptions.value = false;
};
const tryAgain = () => {
  paymentFailed.value = false;
  showPaymentGatewayOptions.value = true;
};
const successfulPayment = (payload) => {
  console.log("payment successful", payload);
  paymentSuccessful.value = payload;
  if (paymentSuccessful.value) {
    paymentDone.value = true;
  } else {
    paymentFailed.value = false;
  }
};
const computeAmount = computed(() => {
  return fullEventData.value.registrationAmount
    ? fullEventData.value.registrationAmount
    : 0;
});
const setTransactionReference = (payload) => {
  donationObj.value.transactionReference = payload;
};

const weddingYearsArr = computed(() => {
  const arrOfYears = [];
  let currentYear = new Date().getFullYear();
  while (arrOfYears.length <= 100) {
    arrOfYears.push(currentYear);
    currentYear = currentYear - 1;
  }
  return arrOfYears;
});

const toggleBase = () => {
  appltoggle.value = !appltoggle.value;
};

const email = computed(() => {
  if (person.value.email) return maskEmail(person.value.email);
  return "";
});
const name = computed(() => {
  if (person.value.name) return formatString(person.value.name);
  return "";
});
const userAddress = computed(() => {
  if (person.value.email) return formatString(address.value.name);
  return "";
});

// searching through the attendance details
const showNoPhoneError = ref(false);
const fetchingFailed = ref(false);
const personHasAddress = ref(false);
const personData = ref({});
const bannerUrl = ref("");
const tenantCurrency = ref("");
const selectedCustomField = ref([]);
const checkinCode = ref("");
const dynamicCustomFields = ref([]);
const date7 = ref();

const resetForm = () => {
  paymentDone.value = false;
  person.value = {};
  appltoggle.value = false;
  enteredValue.value = "";
  birthDay.value = "";
  birthMonth.value = "";
  maritalStatusId.value = null;
  genderId.value = null;
  familyWards.value = { familyMembers: [] };
  displayFamily.value = false;
  paymentFailed.value = false;
  paymentSuccessful.value = false;
};

const getTenantCurrency = () => {
  axios
    .get(`/api/Lookup/TenantCurrency?tenantID=${fullEventData.value.tenantID}`)
    .then((res) => {
      tenantCurrency.value = res.data.currency;
    })
    .catch((err) => console.log(err));
};

const GetAllCurrencies = () => {
  axios
    .get("/api/LookUp/GetAllCurrencies")
    .then((res) => {
      // Get the payment form currency
      paymentFormCurrency.value = res.data.find(
        (i) => i.id == fullEventData.value.currencyID
      );
      console.log(paymentFormCurrency.value, "khkjh");
    })
    .catch((err) => console.log(err.response));
};

const checkCharacter = () => {
  loaded.value = false;
  personHasAddress.value = false;
  fetchingFailed.value = false;
  showNoPhoneError.value = false;
  if (!enteredValue.value) {
    showNoPhoneError.value = true;
    return false;
  }
  loading.value = true;
  autosearch.value = true;
  axios
    .get(
      `/searchregistrationbyphone?searchtext=${enteredValue.value}&id=${route.params.checkinId}`
    )

    .then((res) => {
      loading.value = false;
      autosearch.value = false;
      loaded.value = true;
      names.value = res.data;
      personData.value.firstName =
        res.data.length > 0 ? res.data[0].name.split(" ")[0] : "";
      personData.value.lastName =
        res.data.length > 0 ? res.data[0].name.split(" ")[1] : "";
      personData.value.email = res.data.length > 0 ? res.data[0].email : "";
      personData.value.homeAddress =
        res.data.length > 0 ? res.data[0].address : "";
      personData.value.personId =
        res.data.length > 0 ? res.data[0].personId : "";
      personData.value.dayOfBirth =
        res.data.length > 0 ? res.data[0].dayOfBirth : "";
      personData.value.monthOfBirth =
        res.data.length > 0 ? res.data[0].monthOfBirth : "";
      personData.value.mobilePhone =
        res.data.length > 0 ? res.data[0].phoneNumber : "";
      person.value = res.data.length > 0 ? res.data[0] : {};
      birthDay.value =
        res.data.length > 0 && res.data[0].dayOfBirth
          ? Number(res.data[0].dayOfBirth)
          : 0;
      birthMonth.value =
        res.data.length > 0 && res.data[0].monthOfBirth
          ? months[Number(res.data[0].monthOfBirth) - 1]
          : 0;

      getFamilyDetails(personData.value.personId);
      if (
        person.value.personId &&
        person.value.address &&
        person.value.address !== null &&
        person.value.address !== "" &&
        person.value.address.length >= 1
      ) {
        personHasAddress.value = true;
      }
      populateInputfields(person.value);
      if (person.value) appltoggle.value = true;
    })
    .catch((err) => {
      fetchingFailed.value = true;
      person.value = {};
      loaded.value = true;
      loading.value = false;
      autosearch.value = false;

      if (err.toString().toLowerCase().includes("network error")) {
        ElMessage({
          type: "error",
          message: "Ensure you have internet access and try again",
          duration: 5000,
        });
      } else if (err.message.includes("timeout")) {
        ElMessage({
          type: "error",
          message:
            "The request was taking too long, please reload and try again",
          duration: 5000,
        });
      } else {
        ElMessage({
          type: "error",
          message: "An error occurred, reload and try again",
          duration: 5000,
        });
      }
      console.log(err);
    });
};
//end of searching through the attendance details

// populate input fields
const populateInputfields = (obj) => {
  person.value = obj;
};

const disabled = computed(() => {
  if (person.value.personId) return true;
  return false;
});

// function to disable edit
const disableEdit = (e) => {
  e.preventDefault();
};

// confirm status
const confirm = (idOfNewPerson) => {
  // person.value.attendanceCode = +route.params.code;
  let newPerson = {};
  if (person.value.personId) {
    newPerson = {
      person: {
        personId: personData.value.personId,
        mobilePhone: enteredValue.value,
        homeAddress: personData.value.homeAddress
          ? personData.value.homeAddress
          : "",
        email: personData.value.email ? person.value.email : "",
      },
      id: route.params.checkinId,
    };
  } else {
    newPerson = {
      person: {
        firstName: person.value.name,
        email: person.value.email,
        homeAddress: person.value.address,
        mobilePhone: enteredValue.value,
      },
      id: route.params.checkinId,
    };
    newPerson.person.personId = idOfNewPerson ? idOfNewPerson : "";
  }
  newPerson.person.monthOfBirth = months.indexOf(birthMonth.value) + 1;
  newPerson.person.dayOfBirth = birthDay.value;
  newPerson.checkinCode = fullEventData.value.checkinCode;
  newPerson.person.maritalStatusID = selectedMaritalStatus.value.id;
  newPerson.person.genderID = selectedGender.value.id;
  newPerson.person.yearOfWedding = yearOfWedding.value;
  newPerson.person.monthOfWedding = months.indexOf(monthOfWedding.value) + 1;
  newPerson.person.dayOfWedding = dayOfWedding.value;
  newPerson.customAttributeData = dynamicCustomFields.value.map((i) => ({
    customAttributeID: i.id,
    data: i.data,
    entityID: person.value.personId ? person.value.personId : idOfNewPerson,
  }));
  loading.value = true;
  autosearch.value = true;
  noError.value = true;
  axios
    .post("/EventRegistration", newPerson)
    .then((res) => {
      loading.value = false;
      autosearch.value = false;
      disableClick.value = false;

      swal(
        "Registration Successful!",
        "You have registered for this event successfully!",
        "success"
      );
      appltoggle.value = false;
      loaded.value = false;
    })
    .catch((err) => {
      stopProgressBar();
      loading.value = false;
      autosearch.value = false;
      console.log(err);
      noError.value = false;

      if (err.toString().toLowerCase().includes("network error")) {
        ElMessage({
          type: "error",
          message:
            "Please ensure you have a strong internet connection and try again",
          duration: 5000,
        });
      } else if (err.toString().toLowerCase().includes("timeout")) {
        ElMessage({
          type: "warning",
          message:
            "Request took too long, Please reload the page and try again",
          duration: 5000,
        });
      }
    });
};

// confirm button check

const confirmCheck = () => {
  showPaymentGatewayOptions.value = true;
  const matchedTenantGateway = fullEventData.value?.paymentGateWayOptions?.find(
    (gateway) =>
      gateway?.churchPaymentGateway?.displayName.toLowerCase() ===
      selectedGateway.value?.toLowerCase()
  );
  const matchedGateway =
    fullEventData.value?.paymentForm?.paymentGateWays?.find(
      (gateway) =>
        gateway.paymentGateway?.name.toLowerCase() ===
        selectedGateway.value?.toLowerCase()
    );
  donationObj.value = {
    tenantID: fullEventData.value.tenantID,
    orderID: fullEventData.value.paymentFormOrderID,
    currencyID: fullEventData.value.currencyID,
    paymentFormId: fullEventData.value.id || fullEventData.value.paymentFormId,
    tenantPaymentGatewayOption: matchedTenantGateway || matchedGateway,
    attendanceCode: fullEventData.value.attendanceCode,
    activityId: fullEventData.value.eventID,
    phone: enteredValue.value,
    email: person.value.email,
    amount: computeAmount.value || 0,
    checkInCode: fullEventData.value.checkinCode,
    id: fullEventData.value.id,
    paymentGateway: selectedGateway.value,
    person: person.value.personId
      ? personData.value
      : {
          mobilePhone: enteredValue.value,
          firstName: person.value.name.split(" ")[0]
            ? person.value.name.split(" ")[0]
            : "",
          lastName: person.value.name.split(" ")[1]
            ? person.value.name.split(" ")[1]
            : "",
          email: person.value.email ? person.value.email : "",
        },
    customAttributeData: dynamicCustomFields.value.map((i) => ({
      customAttributeID: i.id,
      data: i.data,
      entityID: person.value.personId
        ? person.value.personId
        : "00000000-0000-0000-0000-000000000000",
    })),
    donation: {
      name: person.value.name,
      email: person.value.email,
      phone: enteredValue.value,
      // paymentFormId: fullEventData.value.paymentFormId,
      tenantID: fullEventData.value.tenantID,
      orderID: fullEventData.value.paymentFormOrderID,
      currencyID: fullEventData.value.currencyID,
      // paymentGateWays: fullEventData.value.paymentForm.paymentGateWays,
      amount: fullEventData.value.registrationAmount || 0,
      contributionItems:
        fullEventData.value?.paymentForm?.contributionItems.map((i) => {
          return {
            contributionItemId: i.financialContribution.id,
            contributionCurrencyId: fullEventData.value.currencyID,
            contributionItemName: i.financialContribution.name,
            amount: fullEventData.value.registrationAmount,
          };
        }),
    },
  };

  if (isPaymentConnected.value) {
    donationObj.value.isPaymentConnected =
      fullEventData.value?.isPaymentConnected;
    donationObj.value.paymentConnectedObject =
      fullEventData.value?.paymentConnectedObject;
  }
};

const initializePayment = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Please wait...",
    background: "rgba(255, 255, 255, 0.9)",
  });
  try {
    let { data } = await axios.post(
      "/initializeEventRegistrationPayment",
      donationObj.value
    );

    if (data.initializePaymentResponseDTO?.data?.authorization_url) {
      checkoutURL.value =
        data.initializePaymentResponseDTO?.data?.authorization_url;
      checkoutDrawer.value = true;
      paymentStatusLoading.value = true;
      checkTransactionStatus(data?.transactionReference);
    }

    if (data.status) {
      initializePaymentResponse.value = data;
      callPayment.value = true;
    } else {
      ElMessage({
        type: "error",
        message: "Could not initialise payment, please try again",
        duration: 5000,
      });
    }
    loading.close();
    finish();
  } catch (error) {
    finish();
    loading.close();
    callPayment.value = false;
    console.log(error);
  }
};

const checkTransactionStatus = async (_ref) => {
  try {
    const response = await ConfirmPaystackTransaction(_ref);
    if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "success"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "failed"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else if (
      paystackTransactionStatusEnum[response?.status]?.toLowerCase() ===
      "cancelled"
    ) {
      paymentStatusLoading.value = false;
      checkoutDrawer.value = false;
      paymentResponseDialog.value = true;
      paymentStatusMessage.value =
        paystackTransactionStatusEnum[response?.status];
    } else {
      setTimeout(() => {
        checkTransactionStatus(response?.transactionReference);
      }, 4000);
    }
  } catch (error) {
    paymentStatusLoading.value = false;
    console.error(error);
  }
};

const confirmToRegister = () => {
  disableClick.value = true;
  // Scenerio when the person exist and we want to create family
  if (personData.value.personId && !familyWards.value.id) {
    if (displayFamily.value) {
      // Create his family
      let familyDetails = {
        fatherId: personData.value.personId,
        familyName: personData.value.firstName,
        familyMembers: familyMembers.value.map((i) => {
          delete i.name;
          return i;
        }),
        tenantId: fullEventData.value.tenantID,
      };
      axios
        .post("/createFamily", familyDetails)
        .then((res) => console.log(res))
        .catch((err) => console.log(err));

      // Register Family members individually
      familyWards.value.familyMembers.forEach((i) => {
        if (i.checkMember) {
          let regFamMembers = {
            person: {
              personId: i.person.id,
            },
            id: route.params.checkinId,
          };
          axios
            .post("/EventRegistration", regFamMembers)
            .then((res) => {
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
      let newFamily = {
        person: {
          personId: personData.value.personId,
          mobilePhone: enteredValue.value,
          homeAddress: personData.value.homeAddress
            ? personData.value.homeAddress
            : "",
          email: personData.value.email
            ? personData.value.email
            : person.value.email,
        },
        id: route.params.checkinId,
      };
      registerMember(newFamily);

      // // Register Family members individually
      // familyWards.value.familyMembers.forEach(i => {
      //   if (i.checkMember) {
      //     let regFamMembers = {
      //       person: {
      //         personId: i.person.id
      //       },
      //       id: route.params.checkinId
      //     }
      //     axios.post("/EventRegistration", regFamMembers).then(res => {
      //       console.log(res)
      //     })
      //       .catch(err => {
      //         console.log(err)
      //       })
      //   }
      // })
      // let newFamily = {
      //   person: {
      //     personId: personData.value.personId,
      //     mobilePhone: enteredValue.value,
      //     homeAddress: personData.value.homeAddress ? personData.value.homeAddress : '',
      //     email: personData.value.email ? personData.value.email : person.value.email,
      //   },
      //   id: route.params.checkinId
      // };
      // registerMember(newFamily)
    } else {
      confirm();
    }
  } else if (personData.value.personId && familyWards.value.id) {
    if (displayFamily.value) {
      // Register Family members individually
      familyWards.value.familyMembers.forEach((i) => {
        if (i.checkMember) {
          let regFamMembers = {
            person: {
              personId: i.person.id,
            },
            id: route.params.checkinId,
          };
          axios
            .post("/EventRegistration", regFamMembers)
            .then((res) => {
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });

      let newFamily = {
        person: {
          personId: personData.value.personId,
          mobilePhone: enteredValue.value,
          homeAddress: personData.value.homeAddress
            ? personData.value.homeAddress
            : "",
          email: personData.value.email
            ? personData.value.email
            : person.value.email,
        },
        id: route.params.checkinId,
      };
      registerMember(newFamily);
    } else {
      confirm();
    }
  } else {
    // If the person doesnt exist in the church's DB
    createNewPerson();
  }
};

const createNewPerson = async () => {
  let createNewPerson = {
    firstName: person.value.name,
    email: person.value.email,
    homeAddress: person.value.address,
    mobilePhone: enteredValue.value,
    tenantId: fullEventData.value.tenantID,
  };

  try {
    let { data } = await axios.post("/createPublicPerson", createNewPerson);
    if (data.status === false) {
      ElMessage({
        dangerouslyUseHTMLString: true,
        type: "warning",
        message: `<strong>${data.response}</strong>`,
        duration: 5000,
      });
      emailNotification.value = data.response;
      disableClick.value = false;
    } else {
      if (displayFamily.value) {
        createNewFamily(data.returnObject.id);
      } else {
        confirm(data.returnObject.id);
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const getGender = async () => {
  try {
    let { data } = await axios.get("/api/LookUp/GetAllLookUps");
    gender.value = data.find((i) => i.type === "Gender").lookUps;
  } catch (err) {
    console.log(err);
  }
};
getGender();

const getMaritalStatus = async () => {
  try {
    let { data } = await axios.get("/api/LookUp/GetAllLookUps");
    maritalStatus.value = data.find((i) => i.type === "MaritalStatus").lookUps;
  } catch (err) {
    console.log(err);
  }
};
getMaritalStatus();

const createNewFamily = (id) => {
  disableClick.value = true;
  let familyDetails = {
    fatherId: id,
    familyName: person.value.name,
    familyMembers: familyMembers.value.map((i) => {
      delete i.name;
      return i;
    }),
    tenantId: fullEventData.value.tenantID,
  };
  axios
    .post("/createFamily", familyDetails)
    .then((res) => console.log(res))
    .catch((err) => console.log(err));

  // Register Family members individually
  familyWards.value.familyMembers.forEach((i) => {
    if (i.checkMember) {
      let regFamMembers = {
        person: {
          personId: i.person.id,
        },
        id: route.params.checkinId,
      };
      axios
        .post("/EventRegistration", regFamMembers)
        .then((res) => {
          console.log(res);
          disableClick.value = false;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  let newFamily = {
    person: {
      personId: id,
      mobilePhone: enteredValue.value,
      homeAddress: personData.value.homeAddress
        ? personData.value.homeAddress
        : "",
      email: personData.value.email
        ? personData.value.email
        : person.value.email,
    },
    id: route.params.checkinId,
  };
  registerMember(newFamily);
};

const registerMember = async (registerData) => {
  disableClick.value = true;
  try {
    let res = await axios.post("/EventRegistration", registerData);
    console.log(res);
    disableClick.value = false;
    swal(
      "Registration Successful!",
      "You have registered for this event successfully!",
      "success"
    );
    displayFamily.value = false;
    familyWards.value.familyMembers = [];
  } catch (error) {
    console.log(error);
  }
};

// function to clear input
const clearNames = () => {
  names.value = [];
};

const notme = () => {
  person.value = {};
  enteredValue.value = "";
};

// getting events and date
const eventData = ref({});
const getDateAndEvent = () => {
  axios
    .get(
      `/api/publiccontent/WebRegistrationEventDetails?id=${route.params.checkinId}`
    )
    .then((res) => {
      eventData.value.name = res.data.fullEventName;
      eventData.value.date = dateFormatter.monthDayYear(res.data.eventDate);
      bannerUrl.value = res.data.bannerUrl;
      fullEventData.value = res.data;
      eventPaymentForm.value = fullEventData.value.paymentForm;
      isPaymentConnected.value = fullEventData.value.isPaymentConnected;
      getTenantCurrency();
      getCustomFields();
      GetAllCurrencies();
    })
    .catch((err) => {
      console.log(err);
    });
};
getDateAndEvent();

/* start masking functions */

// function mask email
const maskEmail = (str, numToShowInFront) => {
  if (str.length > 3) {
    const firstX = str.slice(0, numToShowInFront);
    const midPoint = str.split("").indexOf("@");
    let x = str.split("");
    x.forEach((i, j) => {
      if (j < midPoint) {
        x[j] = "*";
      }
    });
    x = x.join("");
    return firstX + x.slice(numToShowInFront);
  } else {
    return str[0] + "*" + str[2];
  }
};

const formatString = (str, numToShowInFront, numToHide) => {
  if (str.length > 3) {
    const firstX = str.slice(0, numToShowInFront);
    // const midPoint = str.split('').indexOf('@')
    const midPoint = numToShowInFront + numToHide;
    let x = str.split("");
    x.forEach((i, j) => {
      if (j < midPoint) {
        x[j] = "*";
      }
    });
    x = x.join("");
    return firstX + x.slice(numToShowInFront);
  } else {
    return str[0] + "*" + str[2];
  }
};

const showLoading = computed(() => {
  return autosearch.value && !person.value.name;
});

const setGateway = (payload) => {
  selectedGateway.value = payload; // Get the gateway used
  confirmCheck(); // Update the donationObj with the used gateway
  initializePayment(); // make initialize payment call
};

// const setConfirmDonation = () => {
//   swal(
//     "Registration Successful!",
//     "You have registered for this event successfully!",
//     "success"
//   );
// };

const getFamilyDetails = async (id) => {
  if (id) {
    try {
      const res = await axios.get(
        `/family?tenantID=${fullEventData.value.tenantID}&&personId=${id}`
      );
      familyWards.value = res.data;
      if (familyWards.value) {
        familyWards.value.familyMembers.map((i) => {
          i.checkMember = true;
          return i;
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const getFamilyRoles = async () => {
  try {
    let { data } = await axios.get("/getfamilyroles");
    memberRoles.value = data;
    // memberRoles.value = data.result;
  } catch (err) {
    console.log(err);
  }
};
getFamilyRoles();

const setNewMember = (payload) => {
  familyWards.value.familyMembers.push(payload);
};

const setMemberDetails = (payload) => {
  familyMembers.value.push(payload);
  let pushMemberToView = {
    person: {
      firstName: payload.name,
      id: payload.personId,
    },
    familyRoleID: payload.familyRoleId,
    checkMember: payload.checkMember,
  };
  familyWards.value.familyMembers.push(pushMemberToView);
};

// const setDonationProperties = (payload) => {
//   donationNewProps.value = payload
//   confirmCheck()
// }

const getAllRouteQueries = () => {
  for (let i in route.query) {
    if (route.query[i] == "true") {
      selectedCustomField.value.push(i);
    }
  }
};
getAllRouteQueries();

const getCustomFields = async () => {
  try {
    let { data } = await axios.get(
      `/GetAllCustomFields?entityType=4&&tenantID=${fullEventData.value.tenantID}`
    );
    dynamicCustomFields.value = data.sort((a, b) => a.order - b.order);
  } catch (err) {
    console.log(err);
  }
};

const resetCallPayment = (payload) => {
  callPayment.value = payload;
};
</script>

<style scoped>
.notify-text {
  color: #e6a23c;
  /* background-color: #778593;  */
  font-style: italic;
  font-weight: 100 !important;
}

.add-btn {
  /* background: #6aa5e9; */
  background: #136acd;
  color: #ffffff;
  font-weight: bold;
  font-size: 1rem;
  border: none;
}

.eventpictbg {
  background: #ebeff4;
}

.add-btn2 {
  background: none;
}

.loading-indicator {
  font-size: 76px;
  position: absolute;
  margin-top: 86px;
}

.loading-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.italicize {
  font-style: italic;
  font-size: 15px;
}

.event-closed {
  width: 50%;
}

@media (max-width: 400px) {
  .event-closed {
    width: 100%;
  }
}
</style>
